import { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { accountActions } from '../../action/AccountAction';
import breakdownlst from './pricebreakdown.json';
import { commonClass } from '../../helpers/commonClass';
class PriceBreakdown extends Component {
    constructor(props) {
        super(props);
        this.state = { dataLoadCompleted: false };
        this.props.GetPriceBreakdownlst(this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey, this.props.user.Country_code);
    }

    componentDidUpdate(prevState, prevProps) {
        if (this.state.dataLoadCompleted == false && this.state.breakdownlst && this.state.breakdownlst.result && Array.isArray(this.state.breakdownlst.result)) {
            this.state.dataLoadCompleted = true;
            setTimeout(() => { window.PriceBreakdownflex() }, 300);
        }
    }

    createBall = (x) => {
        let ballLst = [];
        for (let i = 1; i <= x.max_ball; i++) {
            ballLst.push(<span className={`bg-game${x.game_group_id}`}>{i}</span>)
        }
        return ballLst;
    }

    createTickBall = (x) => {
        let ballLst = [];
        for (let i = 1; i <= x.max_ball; i++) {
            if (x.matchingball >= i)
                ballLst.push(<span className={`lto-${x.game_group_id}-bg-color lto-${x.game_group_id}-border`}><img src="./assets/img/icons/star.png?v0.1" draggable="false" /></span>)
            else
                ballLst.push(<span className={`lto-${x.game_group_id}-border`}></span>)
        }
        return ballLst;
    }
    static getDerivedStateFromProps(props, state) {
        return {
            breakdownlst: props.breakdownlist
        }
    }

    createTotalBall = (x) => {
        if (x) {
            let ballLst = [];
            for (let i = 1; i <= x.max_ball; i++) {
                if (x.matchingball >= i)
                    ballLst.push(<div className={`headlottoRsltBalls lto-${x.game_group_id}-bg-color`}>{i}</div>)
            }
            return ballLst;
        }
    }



    GenerateRandom = () => {
        let Rnumber = Math.random() * (1 - 1000);
        return Rnumber;
    }
    render() {
        const { t, i18n } = this.props;
        let PriceBreakData = this.state.breakdownlst && this.state.breakdownlst.result && Array.isArray(this.state.breakdownlst.result) && this.state.breakdownlst.result.filter(a => a.game_group_id === this.props.lottoType)
        return (
            <>
                <h2 class="headding2"><span>{t('lblPriceBreak')} - {commonClass.IDWiseGameName(this.props.lottoType)} </span>
                    <div class="headBall">
                        {PriceBreakData && PriceBreakData.length > 0 && this.createTotalBall(PriceBreakData[0])}
                    </div>
                </h2>
                <div class="prizeBrkContain">
                    <div class="prizeBrkCont">
                        {this.state.breakdownlst && this.state.breakdownlst.result && Array.isArray(this.state.breakdownlst.result)
                            && PriceBreakData.map((gObj, ginx) =>
                                <>
                                    <div class="prizeBrkPly">
                                        <div class="lottoRatings">
                                            <p>{gObj.max_ball} {t('lblOutOf')} {gObj.matchingball}</p>
                                            <div class="pBrDnBalls">
                                                {this.createTickBall(gObj)}
                                            </div>
                                            <div class="pBrDnPriDls">
                                                <div class="bg-game14">
                                                    <div class="grandPrice">{gObj.pricetext}</div>
                                                    <span>{this.props.appvariables.currency} {commonClass.aedCrnyConvert(gObj.winamt)} {gObj.starFlag && gObj.starFlag == "1" ? "*" : ""}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                    </div>
                </div>

            </>
        )
    }

}
function mapStateToProps(state) {
    const { breakdownlist } = state.accountReducer;
    const { user, appvariables } = state.loginReducer;
    return { user, breakdownlist, appvariables };
}
const mapActionToProps = {
    GetPriceBreakdownlst: accountActions.GetPriceBreakdownlst
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(PriceBreakdown))

